const NON_ALPHANUMERIC_VALUES_REGEX = /[^a-zA-Z0-9]/;

export const filterTrackingNumberInput = (value) => {
  return value.replace(NON_ALPHANUMERIC_VALUES_REGEX, '').substring(0, 19);
};
